import FindLocalAgent from '@react/shared/components/FindLocalAgent';
import Header from '@react/shared/components/Header/Header.container';
import { AgentsHeaderProps } from 'sly/agentsPage/components/AgentsHeader/AgentsHeader.types';
import HeroBackgroundImage from 'sly/agentsPage/components/AgentsHeader/HeroBackgroundImage';
import HeroTextWrapper from 'sly/agentsPage/components/AgentsHeader/HeroTextWrapper';
import HeroWrapper from 'sly/agentsPage/components/AgentsHeader/HeroWrapper';

export default function AgentsHeader({
  onLocationSearch,
  heroRef,
}: AgentsHeaderProps) {
  return (
    <header className='mb-6'>
      <Header />
      <HeroWrapper heroRef={heroRef}>
        <HeroBackgroundImage />
        <HeroTextWrapper>
          <FindLocalAgent
            onLocationSearch={onLocationSearch}
            placeholder='Search by city or ZIP code'
          />
        </HeroTextWrapper>
      </HeroWrapper>
    </header>
  );
}
